import React, {useEffect, useState} from 'react'
import './TabbedModal.scss'
import ContentBox from "../common/ContentBox/ContentBox";
import DogEar from "../../../partials/DogEar/DogEar";
import SegmentedSlider from "../SegmentedSlider/SegmentedSlider";

export default function TabbedModal(props) {
    const tabsOnTop = props?.tabsOnTop === true
    const doSlider = props?.doSlider === true;
    const isRelax = props?.relax === true;
    let data = props.data.tabs
    if (props?.doAspects) {
        data = props.data.aspects
    }
    const [activeTab, setActiveTab] = useState(data[0].header);
    const [sliderValues, setSliderValues] = useState();
    const handleSliderChange = (s) => {
    }
    useEffect(() => {
     const currentTabOj =  data.find( (t) => t.header === activeTab)
        if (currentTabOj) {
            setSliderValues(currentTabOj.slider)

        }

    }, [activeTab, doSlider])


    return (
        <div className={`TabbedModal ${tabsOnTop ?  "tabsOnTop" : ''} ${isRelax ? 'relax': ''}`}>
            <div className={`modal-tabs ${tabsOnTop ?  "tabsOnTop" : ''}`}>
                {
                    data.map((tab, i) => (
                        <DogEar key={i} className={'dog-ear-tab'}
                            index={0} length={data.length} selected={`${activeTab === tab.header ? 'active-tab' : ''}`}>
                        <div className={`tab ${activeTab === tab.header ? 'active-tab' : ''}`}
                        onClick={() => setActiveTab(tab.header)}
                        key={tab.header+i}>
                            <span>{tab.header}</span>
                        </div>
                        </DogEar>
                    ))
                }
            </div>

                        {data.filter(tab =>  activeTab === tab.header).map((tab, i) => {
                            let header = `${data.name || 'Invalid name'}`
                            if (data.header && props.data.header !== "") {
                                header = `${data.name} (${data.header})`
                            }

                            let intValues = doSlider && tab?.slider && Array.isArray(tab.slider) ? [...Array(tab.slider.length).keys()] : [];

                            return <React.Fragment key={`tab-${i}`}>
                                    <ContentBox title={tab.header} htmlContent={tab.body}>
                                        <div className={'content-box-container'} style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            height:"100%"
                                        }} >
                                            {/*<p style={{flex:1}}>{tab.body}</p>*/}
                                            {doSlider  && <div className={'content-slider'}
                                                style={{
                                                    justifySelf: "flex-end",
                                                    marginBottom: "40px"
                                                }}
                                            >
                                                {data.map(t => {

                                                    return  activeTab === t.header ? <SegmentedSlider onChange={(s) => props?.onSliderChange && props.onSliderChange(t.header,s)}
                                                                            values={[...intValues]}></SegmentedSlider> : <></>
                                                })}
                                            </div>}
                                        </div>
                                    </ContentBox>
                                {/*<div className='header-tab'/>*/}
                                {/*<h2 className={'text-header'}>{header}</h2>*/}
                                {/*<p>{tab.body}</p>*/}
                            </React.Fragment>
                        })}


        </div>
    );
}
